import React from "react";
import { ArrowUpRight, Fan, Flame, ShieldCheck, Wind } from "lucide-react";
import { SERVICES } from "@/data/siteContent";

const ICONS = { heat: Flame, cool: Wind, commercial: Fan, air: ShieldCheck };

export default function Services({ language }) {
  return (
    <section className="services-section" id="services" data-testid="services-section">
      <div className="section-shell">
        <div className="section-header reveal"><span className="section-label">{language === "en" ? "04 // Field capability" : "04 // Capacidad en campo"}</span><div><h2 className="section-title">{language === "en" ? "One team. Every season." : "Un equipo. Cada temporada."}</h2><p className="section-intro">{language === "en" ? "From the first call to the last check, Protech keeps the experience clear, practical, and built around your space." : "Desde la primera llamada hasta la última revisión, Protech mantiene el proceso claro, práctico y pensado para tu espacio."}</p></div></div>
        <div className="services-grid">
          {SERVICES.map((service, index) => {
            const Icon = ICONS[service.icon];
            return <article className="service-card reveal" key={service.number} style={{ transitionDelay: `${index * 80}ms` }} data-testid={`service-card-${service.icon}`}><div className="service-icon"><Icon /></div><span className="service-number">{service.number}</span><h3 className="service-title">{service.title[language]}</h3><p className="service-copy">{service.copy[language]}</p><a className="service-link" href="#contact" data-testid={`service-${service.icon}-link`}>{language === "en" ? "Talk to Protech" : "Hablar con Protech"}<ArrowUpRight /></a></article>;
          })}
        </div>
      </div>
    </section>
  );
}
